// extracted by mini-css-extract-plugin
export default {"gb":"gb","gb_title":"gb_title","gb_title_font":"gb_title_font"};